import React from 'react';
import { ApiStore, Subscribe } from 'Store';
import styled from 'styled-components';

// Components
import { Header, Anchor } from 'Components/core';
import Card from 'Components/Card';
import CardContainer from 'Components/Card/CardContainer';

// Icons
import AlarmIcon from 'Icons/alarm.svg';
import MedkitIcon from 'Icons/medkit.svg';
import StethoscopeIcon from 'Icons/stethoscope.svg';
import CODES from 'Root/libs/analytics/CodeDef';

const Title=styled.div`
display:flex;
justify-content:center;
color:#0d7abf;
font-weight:bold;
`;

const Announcement=styled.p`
text-align:center;

`;

export default props => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <div>
        <Title>COVID-19 assistance</Title>
        <Announcement>We’re here to help you through the difficulties of dealing with COVID-19. For up-to-date information on all {state.brandInfo.name} is doing to assist members during this time, visit our Coronavirus Resource Center at   <Anchor code={CODES.HOME_CORONA_CLICK} to={state.brandInfo.webLink+'coronavirus'}>{state.brandInfo.webLink}coronavirus</Anchor>.</Announcement>
      </div>
 
    )}
  </Subscribe>
);
